__turbopack_context__.v({
  "arrow": "mortgage-calculator-callout-module-scss-module__I9jTxa__arrow",
  "callout": "mortgage-calculator-callout-module-scss-module__I9jTxa__callout",
  "icon": "mortgage-calculator-callout-module-scss-module__I9jTxa__icon",
  "label": "mortgage-calculator-callout-module-scss-module__I9jTxa__label",
  "link": "mortgage-calculator-callout-module-scss-module__I9jTxa__link",
});
